<template>
  <div class="pspeech">
    <PinchInImg v-show="showPinchIn"/>
    <div class="page-content">
      <div class="inner flexrow" :class="cssLayoutID">

        <div id="toparea" class="toparea-mic" :style="toparea_visible">
          <div class="item-wrap flexcenter">
            <div id="inputarea" class="item bgdgray bdgreen w300" :class="{ 'textmgray': isTextGray }">
              {{ inputString }}
              <div class="mic-icon" :class="scoreNum"></div>
            </div>
            <div id="ssbutton" class="icon-skip" v-on:click="skipQuestion"></div>
          </div>
        </div>

        <template v-if="isEnvironmentPc()">
          <div class="cards-container active-type2 card-voice">
            <template v-for="(actblock, index) in acts">
              <div :class="actblock[0].layoutClass" :key="index">
                <template v-for="(act, index2) in actblock">
                  <div :id="act.active_id" :class="act.active" :name="act.sound" :key="index2">
                    <p :id="act.text_id" v-html="getText(act)"/>
                    <div class="card">
                      <div class="image"><img v-bind:src="act.image"></div>
                      <button :id="act.sbutton_id" class="icon-voice" :style="act.sbutton_visible"></button>
                      <div :id="act.correct_id"></div>
                    </div>
                  </div>
                </template>
              </div>  
            </template>
          </div>
        </template>
        <template v-else>
          <div class="cards-container swiper-container swiper-container1 active-type2 card-voice">
            <div class="swiper-wrapper">
              <template v-for="(actblock, index) in acts">
                <div :class="actblock[0].layoutClass" :key="index">
                  <div class="swiper-container swiper-container2" >
                    <div class="swiper-wrapper">
                      <template v-for="(act, index2) in actblock">
                        <div :id="act.active_id" :class="act.active" :name="act.sound" :key="index2">
                          <p :id="act.text_id" v-html="getText(act)"/>
                          <div class="card">
                            <div class="image" @touchstart="onTouchStart(act.image)"
                              @touchend="onTouchEnd()" @touchmove="onTouchEnd()"><img v-bind:src="act.image"></div>
                            <button :id="act.sbutton_id" class="icon-voice" :style="act.sbutton_visible"></button>
                            <div :id="act.correct_id"></div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>

      </div>
    </div>

  </div>
</template>

<script>
import common from "@/mixin/common";
import runmode from "@/mixin/runmode";
import * as commonLayout from "@/mixin/PLayout";
import * as constants from "@/store/constants";
import * as mixinConstants from "@/mixin/constants";

// 画像拡大モーダルコンポーネント
import PinchInImg from "./PinchInImg";

var lodash = require("lodash");
var mySession = "";

var jtext = "問題文";
var actimage = "static/demo/images/001.jpg";
var step;
var sub_step;

var question0;
var question1;
var question2;
var question3;

//var inputString
var nowInput;
var soundPlay;
var soundPlaying;

var specialKey;

var timerCount;
var cardHomeX = 100;
var cardHomeY = 200;
var cardSpaceX = 50;
var cardWidth = 200;

var key_enter = "✔︎ x";
var key_backspace = "bs";

var input_active;

var skipFlag;
var layiutID;

export default {
  name: "PSpeech",
  props: [
    "pathstepIndex",
    "pathstep"
  ],
  mixins: [
    common,
    runmode
  ],
  data() {
    return {
      jsondata: "",
      input_active: "item",
      layoutID: -1,
      correct_class: [],
      // スコア
      scoreLevel: 0,
      sonic_timeout: 0,
      voiceStatus: true,
      timer: null,
      exitFlag: false,
      // グレー文字
      isTextGray: true,
      pause_flag: false,
      inputString: "",
      // 正解ステータスカウント用
      correctIndex: [],
      // 不正解ステータスカウント用
      incorrectIndex: [],
      toparea_visible: "visibility:visible;",
      startFlag: false,
      startCheckFlag: false,
      nextQuestionFlag: false,
      soundPath: "",
      updateFlag: false,
      stopFlag: false,
      layoutClassPointer: -1,
      layoutClassCount: 0,
      acts: [],
      // タッチイベント長押しタイマー
      touchTimer: null
    };
  },
  components: {
    PinchInImg
  },
  computed: {
    scoreNum: function() {
      return "score_" + this.scoreLevel;
    }
  },
  watch: {
    // ツールバー「日本語翻訳を表示する」の選択状態を監視する
    dispJapaneseStatus: function(newstatus) {
      this.log("PSpeech watch dispJapaneseStatus");

      if (this.dispJapaneseStatus == false) {
        if (this.dispAllAnswerStatus == false) {
          this.applyParrotCardAreaSize();
          this.changeunDisp();
        }
      } else {
        this.applyParrotCardAreaSize();
        this.changeDispJapanese();
      }
    },
    // ツールバー「全解答を表示する」の選択状態を監視する
    dispAllAnswerStatus: function(newstatus) {
      this.log("PSpeech watch dispAllAnswerStatus");

      if (this.dispAllAnswerStatus == false) {
        if (this.dispJapaneseStatus == false) {
          this.applyParrotCardAreaSize();
          this.changeunDisp();
        }
      } else {
        this.applyParrotCardAreaSize();
        this.changeDispAnswer();
      }
    },
    lessonState: function(state) {
      // ステータス処理
      if (state == constants.LESSON_STATE_STOP) {
        this.stopFlag = true;
      } else if (state == constants.LESSON_STATE_PAUSE) {
        // レッスン停止
        this.lessonPause();
      } else if (state == constants.LESSON_STATE_RESTART) {
        // レッスンリスタート
        this.lessonRestart();
      } else if (state == constants.LESSON_STATE_START) {
        // 出題開始！
        this.startFlag = true;
        this.startCheckFlag = true;
      }
      // 表示領域自動調整
      this.autoAdjustFirstShownParrot();
    }
  },
  methods: {
    lessonPause: function() {
      this.log("------ lesson pause -------");
      this.pause();
    },
    lessonRestart: function() {
      this.log("------ lesson restart ------");
      if (this.dispJapaneseStatus == false) {
        if (this.dispAllAnswerStatus == false) {
          this.resume();
        }
      }
    },
    changeunDisp: function() {
      this.log("-------- cancel answer display");

      for (var i = 0; i < this.jsondata["acts"].length; i++) {
        this.jsondata["acts"][i]["text"] = "<SPAN>" + this.jsondata["acts"][i]["text0"] + "</SPAN>";
        var elem = document.getElementById("text" + i);
        elem.innerHTML = this.jsondata["acts"][i]["text"];
        this.log(this.jsondata["acts"][i]["text"]);
      }
      this.resume();
    },
    changeDispJapanese: function() {
      this.log("-------- japanese display");

      for (var i = 0; i < this.jsondata["acts"].length; i++) {
        this.jsondata["acts"][i]["text"] = "<SPAN>" + this.jsondata["acts"][i]["japaneseText"] + "</SPAN>";
        var elem = document.getElementById("text" + i);
        elem.innerHTML = this.jsondata["acts"][i]["text"];
        this.log(this.jsondata["acts"][i]["text"]);
      }
      this.toparea_visible = "visibility:hidden;";
      this.pause();
    },
    changeDispAnswer: function() {
      this.log("------- all answer display");

      for (var i = 0; i < this.jsondata["acts"].length; i++) {
        this.jsondata["acts"][i]["text"] = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][i]["basicText"]) + "</SPAN>";
        var elem = document.getElementById("text" + i);
        elem.innerHTML = this.jsondata["acts"][i]["text"];
        this.log(this.jsondata["acts"][i]["text"]);
      }
      this.toparea_visible = "visibility:hidden;";
      this.pause();
    },
    pause: function() {
      this.log("------ pause ------");

      this.pause_flag = true;

      if (sonic_wrapper.isSessionRunning()) {
        sonic_wrapper.interruptSession();
        return;
      } else {
        this.pauseMain();
      }
    },
    getText: function(act) {
      return act.text;
    },
    pauseMain: function() {
      if (this.audioPlaying === true && this.myAudio != null) {
        // 音声停止
        this.myAudio.pause();
        // 音声再生中フラグ変更
        this.audioPlaying = false;
      }

      this.sbuttonActive();
    },
    resume: function() {
      this.log("------ resume ------");
      // ◯×を消す
      var elem = document.getElementById("correct_id" + step);
      if (elem != undefined) {
        elem.className = "";
      }

      this.toparea_visible = "visibility:visible;";

      this.soundPlaying = true;
      this.audioPlaying = false;
      this.pause_flag = false;

      if (sub_step >= 2) {
        this.nextQuestion();
      } else {
        sub_step = 0;
      }
    },
    getObjectSize: function(obj) {
      var a = obj.length;
      if (a === undefined) {
        a = 1;
      }
      return a;
    },
    // スライドさせる
    slide: function(num) {
      if (this.isEnvironmentPc()) {
        return;
      }

      var max = this.jsondata["acts"].length;
      if (num >= max) {
        return;
      }
      this.log("------- swipe:" + num + " ------");
      this.log("------- swiperIn:" + this.swiperIn.length + " ------");

      var cnt = this.getObjectSize(this.swiperIn);

      if (cnt === 1) {
        this.swiperIn.slideTo(num);
      } else {
        var off = 0;

        this.log("---- this.acts=" + this.acts + " -----");

        this.log("0:------- step=" + step + " off=" + off + " num=" + num);

        this.log("---- acts[" + off + "].length=" + this.getObjectSize(this.acts[off]));
        while (off < cnt && this.getObjectSize(this.acts[off]) <= num) {
          num -= this.getObjectSize(this.acts[off]);
          off++;
          this.log("num=" + num + " off=" + off);
        }
        this.log("1:------- step=" + step + " off=" + off + " num=" + num);
        this.swiperOut.slideTo(off);
        this.swiperIn[off].slideTo(num);
      }
    },
    getSwipeWrapper: function() {
      var str = "swiper-wrapper ";
      if (this.isEnvironmentPc()) {
        str = "";
      }
      return str;
    },
    getSwiperSlide: function() {
      var str = "swiper-slide ";
      if (this.isEnvironmentPc()) {
        str = "";
      }
      return str;
    },
    setCards: function() {
      this.jsondata = this.pathstep;

      var max = this.jsondata["acts"].length;
      this.log("count:" + max);

      var i;

      this.layoutID = this.jsondata["layoutID"];

      this.log("this.layoutID::" + this.layoutID);

      this.toparea_visible = "visibility:visible;";

      for (i = 0; i < max; i++) {
        // レイアウト用クラスの設定
        this.jsondata["acts"][i]["layoutClass"] = "";

        if (this.layoutClassCount == 0) {
          var id = 0;
          for (var j = 0; j < commonLayout.layoutClassTable.length; j++) {
            if (commonLayout.layoutClassTable[j][0] == this.layoutID) {
              id = j;
              break;
            }
          }
          this.layoutClassPointer++;
          this.acts[this.layoutClassPointer] = Array();

          this.jsondata["acts"][i]["layoutClass"] = "card-inner " + this.getSwiperSlide() + commonLayout.layoutClassTable[id][this.layoutClassPointer + 1][0];
          this.layoutClassCount = commonLayout.layoutClassTable[id][this.layoutClassPointer + 1][1];

          this.log(i + "::layoutClass=" + this.jsondata["acts"][i]["layoutClass"]);
        }
        this.layoutClassCount--;

        // 要素の設定
        actimage = this.jsondata["acts"][i]["image"];
        jtext = this.jsondata["acts"][i]["basicText"];
        this.log("actimage=" + actimage + " jtext=" + jtext);
        var x;
        var y;

        this.jsondata["acts"][i]["posx"] = x + "px";
        this.jsondata["acts"][i]["posy"] = y + "py";

        this.jsondata["acts"][i]["style"] = "";

        this.jsondata["acts"][i]["text"] = "";
        this.jsondata["acts"][i]["text0"] = "";

        this.jsondata["acts"][i]["sbutton_visible"] = "visibility:visible;";

        if (this.jsondata["acts"][i]["challenge"] != 0 && this.jsondata["mode"] == mixinConstants.RUNMODE_PNT && this.voiceStatus == true) {
        } else {
          if ((this.jsondata["mode"] != mixinConstants.RUNMODE_PNTSPEECH && this.jsondata["acts"][i]["challenge"] != 2) || this.voiceStatus == false) {
            this.jsondata["acts"][i]["text"] = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][i]["basicText"]) + "</SPAN>";
            this.jsondata["acts"][i]["text0"] = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][i]["basicText"]) + "</SPAN>";
          }
        }

        this.jsondata["acts"][i]["text_id"] = "text" + i;
        this.jsondata["acts"][i]["sbutton_id"] = "sbutton" + i;
        this.jsondata["acts"][i]["correct_id"] = "correct_id" + i;
        this.jsondata["acts"][i]["active_id"] = "active" + i;

        this.jsondata["acts"][i]["sbutton"] = "sbutton" + i;

        if (this.jsondata["acts"][i]["challenge"] === 0) {
          this.jsondata["acts"][i]["active"] = "item " + this.getSwiperSlide() + "given disabled";
        } else {
          this.jsondata["acts"][i]["active"] = "item " + this.getSwiperSlide() + "challemge-gray disabled";
        }

        this.correct_class[i] = "";

        this.jsondata["acts"][i]["answerText"] = "";
        this.jsondata["acts"][i]["answerText"] = jtext;

        this.jsondata["acts"][i]["answer_id"] = "answer" + i;

        this.acts[this.layoutClassPointer].push(this.jsondata["acts"][i]);
      }
    },
    setCards2: function() {
      var i;
      const self = this;

      var data = this.jsondata;
      var max = data["acts"].length;

      for (i = 0; i < max; i++) {
        var elem2 = document.getElementById("active" + i);
        elem2.name = data["acts"][i]["sounds"][0];
        elem2.onclick = function(e) {
          var n;
          var target = e.target;
          while (target.id.substr(0, 6) != "active") {
            target = target.parentNode;
          }

          if (target.className != "item " + self.getSwiperSlide() + "disabled") {
            n = target.id.substr(6, 1);

            var elem = document.getElementById("sbutton" + n);
            elem.name = data["acts"][n]["sounds"][0];
            if (elem.className !== "icon-voice disabled" && data["acts"][n]["sbutton_visible"] != "visibility:hidden;") {
              if (sonic_wrapper.isSessionRunning()) {
                self.soundPath = elem.name;
                sonic_wrapper.interruptSession();
              } else {
                self.sbuttonActive(false);

                self.autoPlay(elem.name, 10);

                sub_step = 0;

                self.soundPlay = true;
                self.soundPlaying = false;
              }
            }
          }
        };
      }

      for (i = 0; i < max; i++) {
        document.getElementById("sbutton" + i).name = data["acts"][i]["sounds"][0];
        document.getElementById("sbutton" + i).onclick = function(e) {
          if (e.target.className !== "icon-voice disabled") {
            var n = e.target.id.substr(7, 1);
            self.log("play soound!!" + e.target.name);

            if (sonic_wrapper.isSessionRunning()) {
              self.soundPath = e.target.name;
              sonic_wrapper.interruptSession();
            } else {
              self.sbuttonActive(false);

              self.autoPlay(e.target.name, 10);

              sub_step = 0;

              self.soundPlay = true;
              self.soundPlaying = false;
            }
          }
        };
      }

      self.sbuttonActive(false);
      this.timerTick();

      if (!this.isEnvironmentPc()) {
        this.sliderInit();
      }
    },
    init: function() {
      this.log("PSpeech::init()");

      if (this.$store.getters.lessonState == constants.LESSON_STATE_START) {
        this.startFlag = true;
        this.startCheckFlag = true;
      }

      this.voiceStatusCheck();

      step = 0;
      sub_step = 0;
      this.setCards();
      timerCount = 0;

      specialKey = "";

      this.audioPlaying = false;

      this.soundPlay = true;
      this.soundPlaying = false;

      this.backDisabled = false;
      this.goDisabled = false;

      if (document.addEventListener) {
        // キーボードを押したときに実行されるイベント
        document.addEventListener("keydown", this.keyDownFunc);
      }

      input_active = "item";
    },
    setActive: function() {
      var elem;

      var max = this.jsondata["acts"].length;

      if (step < max) {
        // 次の問題をアクティブに
        elem = document.getElementById("active" + step);
        if (this.jsondata["acts"][step]["challenge"] == 0) {
          elem.className = "item " + this.getSwiperSlide() + "given active";
        } else {
          elem.className = "item " + this.getSwiperSlide() + "challenge-gray active";
        }
      }
      if (step > 0) {
        // 前の問題を非アクティブに
        elem = document.getElementById("active" + (step - 1));
        if (elem != null) {
          elem.className = "item " + this.getSwiperSlide() + "challenge-white";
        }
      }

      // 入力エリアをクリア
      this.inputString = "";

      this.scoreLevel = 0;
      this.isTextGray = true;
    },
    // キーダウンイベント
    keyDownFunc: function(e) {
      if (e.keyCode === 13) {
        this.log("enter key down!!");
        var elem = document.getElementById("inputtext");
        this.inputString = elem.value;
        this.specialKey = key_enter;
      }
    },
    setVoiceInput() {
      if (this.voiceStatus) {
        var text = this.tagErase(this.jsondata["acts"][step]["basicText"]);
        this.log("speach text::" + text);
        this.listenForPhrases(text);

        input_active = "item active";
        this.inputString = "";
        this.isTextGray = true;
        this.scoreLevel = 0;
      } else {
        this.log("----- setVoiceInput voice disabled -----");
        // 正解数更新
        if (this.jsondata["acts"][step]["challenge"] != 0 && !_.includes(this.incorrectIndex, step)) {
          this.correctIndex.push(step);
          this.setActState(true);
        }
        this.sbuttonActive(false);

        this.isTextGray = false;

        this.sonic_timeout = 0;

        var s = step;
        this.nextQuestion();

        if (s == step) {
          step++;
          this.slide(step);
        }
        sub_step = 2;
      }
    },
    sbuttonActive: function(state) {
      this.log("sbuttonActive " + state);
      var max = this.jsondata["acts"].length;

      if (this.pause_flag == false) {
        var elem = document.getElementById("ssbutton");
        if (state == true) {
          elem.className = "icon-skip";
        } else {
          elem.className = "icon-skip disabled";
        }
      }
      for (var i = 0; i < max; i++) {
        var elem = document.getElementById("sbutton" + i);
        if (elem != undefined) {
          if (state == false) {
            elem.className = "icon-voice disabled";
          } else if (i <= step) {
            if (elem.className == "icon-voice disabled") {
              elem.className = "icon-voice";
            }
          }
        }
      }
    },
    // 音声入力が有効か調べる
    voiceStatusCheck: function() {
      this.voiceStatus = true;
      if (this.$store.getters.sreUse != "true") {
        this.voiceStatus = false;
      }
    },
    timerTick: function() {
      if (this.stopFlag == true) {
        this.log("********* skip ********");

        if (this.timer != null) {
          clearTimeout(this.timer);
        }

        if (this.audioPlaying === true && this.myAudio != null) {
          // 音声停止
          this.myAudio.pause();
          this.audioPlaying = false;
        }

        if (sonic_wrapper.isSessionRunning()) {
          sonic_wrapper.interruptSession();
        } else {
          this.log("stop act");
          this.$emit("stopAct");
        }

        return;
      }

      if (this.nextQuestionFlag) {
        this.timer = setTimeout(this.timerTick, 10);
        return;
      }
      if (this.startFlag == false) {
        this.timer = setTimeout(this.timerTick, 10);
        return;
      }
      if (this.startCheckFlag == true) {
        // 最初の読み上げ
        this.setActive();
        this.autoPlay(this.currentAct.sounds[0], 100);
        this.startCheckFlag = false;
      }

      this.voiceStatusCheck();

      if (this.pause_flag) {
        if (this.soundPlay == true && this.audioPlaying === true) {
          this.soundPlaying = true;
        }

        if (this.soundPlaying === true && this.audioPlaying === false) {
          this.soundPlay = false;
          this.soundPlaying = false;

          this.sbuttonActive(true);
        }
        if (this.exitFlag === false) {
          this.timer = setTimeout(this.timerTick, 10);
        }
        return;
      }

      var data = this.jsondata;
      var max = data["acts"].length;

      if (skipFlag) {
        skipFlag = false;

        this.nextQuestion();
      } else {
        if (this.soundPlay == true && this.audioPlaying === true) {
          this.soundPlaying = true;
        }

        if (this.soundPlaying === true && this.audioPlaying === false) {
          this.log("sound end!!");
          this.soundPlay = false;
          this.soundPlaying = false;

          this.sbuttonActive(true);

          // ◯×を消す
          var elem = document.getElementById("correct_id" + step);
          if (elem != undefined) {
            elem.className = "";
          }

          if (data["acts"][step]["challenge"] == 0) {
            this.nextQuestion();
          } else {
            if (this.voiceStatus == false) {
              this.setVoiceInput();
            } else if (sub_step === 0) {
              if (!sonic_wrapper.isSessionRunning()) {
                this.log("-------- speach start --------");
                this.setVoiceInput();

                this.sbuttonActive(true);

                this.nowInput = true;

                sub_step++;
              }
            } else if (sub_step === 2) {
              this.autoPlay(data["acts"][step]["sounds"][0], 1000);
              this.soundPlay = true;
              this.soundPlaying = false;

              sub_step++;

              this.sbuttonActive(false);
            } else if (sub_step === 3) {
              this.nextQuestion();
            }
          }
        }
      }

      timerCount++;

      if (this.exitFlag === false) {
        this.timer = setTimeout(this.timerTick, 10);
      }
    },
    nextQuestion: function() {
      const self = this;

      this.log("next question!!");

      if (sonic_wrapper.isSessionRunning() && this.nextQuestionFlag == false) {
        this.log("------ necxtQuestion::interruptSession");
        this.nextQuestionFlag = true;
        sonic_wrapper.interruptSession();
        return;
      }

      if (this.audioPlaying === true && this.myAudio != null) {
        // 音声停止
        this.myAudio.pause();
        // 音声再生中フラグ変更
        this.audioPlaying = false;
      }

      var data = this.jsondata;
      var max = data["acts"].length;

      this.nowInput = false;

      this.soundPlaying = false;

      step++;
      this.slide(step);
      sub_step = 0;

      if (step >= max) {
        this.setActive();

        this.sbuttonActive(false);

        for (var i = 0; i < max; i++) {
          var elem = document.getElementById("text" + i);
          elem.innerHTML = "<SPAN>" + this.getPopupTextElem(this.jsondata["acts"][i]["basicText"]) + "</SPAN>";
        }

        setTimeout(function() {
          self.checkNextAct();
        }, mixinConstants.ALLCORRECT_INTERVAL);

        return;
      } else {
        this.setActive();

        if (data["acts"][step]["challenge"] != 2 || this.voiceStatus == false) {
          this.autoPlay(data["acts"][step]["sounds"][0], 1000);
          this.soundPlay = true;
          this.soundPlaying = false;

          this.sbuttonActive(false);
        } else {
          if (this.voiceStatus == false) {
            this.autoPlay(data["acts"][step]["sounds"][0], 1000);
          }

          this.soundPlay = true;
          this.soundPlaying = true;
        }
      }
    },
    tagErase: function(str) {
      return str.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, "");
    },
    // actの表示制御
    showAct: function(index) {
      return index <= this.currentActIndex;
    },
    // 入力フォームの表示
    showForm: function(index) {
      if (index === this.currentActIndex && this.showCurrentForm === true) {
        return true;
      } else {
        return false;
      }
    },
    // 問題のスキップ
    skipQuestion: function() {
      var elem = document.getElementById("ssbutton");
      if (elem.className === "icon-skip") {
        this.log("skip!!");
        skipFlag = true;
      }
    },
    // 音声解析実行
    listenForPhrases: function(phrases) {
      // イベントと同じ名前で実行したい関数を指定する
      // 特に処理する必要のないイベントに関しては指定しない
      var callbacks = {
        start: this.listenForPhrasesStart,
        update: this.listenForPhrasesUpdate,
        error: this.listenForPhrasesError,
        interrupting: this.listenForPhrasesInterrupting,
        success: this.listenForPhrasesSuccess,
        end: this.listenForPhrasesEnd
      };
      phrases = this.nounString(phrases);
      sonic_wrapper.listenForPhrases([phrases], callbacks);

      this.updateFlag = false;
    },
    listenForPhrasesStart() {
      // startイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesStart");
    },
    listenForPhrasesUpdate() {
      // updateイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesUpdate");

      if (sonic_wrapper.hasLfpHypothesisResponse()) {
        var response = sonic_wrapper.getLfpResponse();
        this.inputString = response;
      }
      this.updateFlag = true;
    },
    listenForPhrasesError() {
      // errorイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesError");
    },
    listenForPhrasesInterrupting() {
      // interruptingイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesInterrupting");
    },
    listenForPhrasesSuccess() {
      // successイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesSuccess");
    },
    phraseCheck: function() {
      var elem;

      const self = this;

      var score = 0;
      if (sonic_wrapper.hasLfpHypothesisScore()) {
        score = sonic_wrapper.getLfpScore();
        this.scoreLevel = score;
      }

      self.log("-------- step=" + step + " sub_step=" + sub_step + " -----------");

      if (score >= mixinConstants.CORRECT_SCORE) {
        self.log("------------ success!!!! ------------");
        // 正解音
        if (this.$store.getters.answerSound == "true") {
          this.autoPlay("static/resource/sound/correct.mp3", 10);
        } else {
          this.correctDummyFunc();
        }
        this.sbuttonActive(false);

        this.isTextGray = false;

        self.inputString = this.tagErase(self.jsondata["acts"][step]["basicText"]);

        if (self.jsondata["mode"] !== mixinConstants.RUNMODE_PNTSPEECH) {
          elem = document.getElementById("text" + step);
          elem.innerHTML = "<SPAN>" + this.getPopupTextElem(self.jsondata["acts"][step]["basicText"]) + "</SPAN>";
        }
        self.soundPlay = true;
        self.soundPlaying = false;

        self.jsondata["acts"][step]["active"] = "item " + this.getSwiperSlide() + "active";

        elem = document.getElementById("correct_id" + step);
        this.log("collect:" + elem);
        elem.className = "correct";

        sub_step++;

        // 正解数更新
        if (!_.includes(this.incorrectIndex, step)) {
          this.correctIndex.push(step);
          this.setActState(true);
        }
      } else {
        self.log("------------ bad!!!! ------------");

        // 不正解数更新
        if (!_.includes(this.incorrectIndex, step)) {
          this.incorrectIndex.push(step);
          this.setActState(false);
        }

        // 不正解
        if (this.$store.getters.answerSound == "true") {
          this.autoPlay("static/resource/sound/incorrect.mp3", 10);
        } else {
          this.correctDummyFunc();
        }
        this.sbuttonActive(false);

        if (this.isEnvironmentPc()) {
          self.jsondata["acts"][step]["active"] = "item active";
        } else {
          self.jsondata["acts"][step]["active"] = "item active swiper-slide";
        }

        elem = document.getElementById("correct_id" + step);
        this.log("collect:" + elem);
        elem.className = "incorrect";

        self.soundPlay = true;
        self.soundPlaying = false;

        sub_step--;
      }
    },
    audioEnd: function() {
      this.log("--------- correct sound end dummy!!");
      this.audioPlaying = false;
      this.soundPlaying = true;
    },
    correctDummyFunc: function() {
      setTimeout(this.audioEnd, 1000);
    },
    listenForPhrasesEnd() {
      var elem;

      // endイベント発火時に行いたい処理を実装できる
      this.log("listenForPhrasesEnd");

      if (this.nextQuestionFlag) {
        this.log("------- sonic.globals.getSTOP_REASON_MANUAL : nextQuestion -------");

        this.nextQuestion();

        this.nextQuestionFlag = false;
      } else if (sonic_wrapper.isStopReasonManual()) {
        if (this.stopFlag) {
          this.log("stop act");
          this.$emit("stopAct");
        } else if (this.exitFlag) {
          this.log("end act");
          this.$emit("endAct");
        } else {
          this.log("------- sonic.globals.getSTOP_REASON_MANUAL -------");

          if (this.pause_flag) {
            this.log("------- sonic.globals.getSTOP_REASON_MANUAL : pause -------");

            this.pauseMain();
          } else if (this.soundPath != "") {
            this.log("------- sonic.globals.getSTOP_REASON_MANUAL : sound play -------");

            this.sbuttonActive(false);

            this.autoPlay(this.soundPath, 10);

            sub_step = 0;

            this.soundPlay = true;
            this.soundPlaying = false;

            this.soundPath = "";
          }
        }
      } else if (!sonic_wrapper.isCalibrationResultOk()) {
        // タイムアウト
        this.log("----- timeout ------");
        this.sonic_timeout++;
        this.scoreLevel = 0;
        if (this.sonic_timeout >= 2) {
          // タイムアウトが2回連続発生
          this.sonicTimeoutCount = 0;
          this.openMicDialog();
        } else {
          sub_step = 0;
          this.soundPlaying = true;
          this.audioPlaying = false;
        }
      } else {
        if (this.updateFlag == false) {
          this.sonicTimeoutCount = 0;
          this.scoreLevel = 0;
          this.openMicDialog();
        } else if (!sonic_wrapper.isStopReasonManual()) {
          this.phraseCheck();
        }
      }
    },
    openMicDialog: function() {
      this.log("-------- mic dialog open ---------");
      this.sonic_timeout = 0;
      this.$emit("showMicrophoneErrorDialog");
    },
    checkNextAct: function() {
      this.log("---- checkNextAct ----");
      const self = this;
      self.log("- currentActIndex=" + self.currentActIndex + " -");

      self.sbuttonActive(false);

      self.exitFlag = true;

      if (self.timer != null) {
        clearTimeout(self.timer);
      }

      if (sonic_wrapper.isSessionRunning()) {
        sonic_wrapper.interruptSession();
      } else {
        self.log("end act 2");
        self.$emit("endAct");
      }
    },
    /**
     * 長押しイベント開始
     *
     * @param String imgpath 画像パス
     */
    onTouchStart: function(imgpath) {
      this.log("PSpeech start TouchEvent::" + imgpath);
      if (this.isEnvironmentPc()) {
        // PCの場合は表示しない
        return;
      }
      var self = this;

      this.touchTimer = setTimeout(function() {
        self.showPinchInImage(imgpath);
      }, mixinConstants.LONGTOUCH_DURATION);
    },
    /**
     * 長押しイベント終了
     */
    onTouchEnd: function() {
      this.log("PSpeech end TouchEvent");
      clearTimeout(this.touchTimer);
    }
  },
  beforeDestroy: function() {
    this.log("------ beforeDestroy ------");
    this.exitFlag = true;

    if (this.myAudio != null) {
      // 音声停止
      this.myAudio.pause();
    }

    if (sonic_wrapper.isSessionRunning()) {
      sonic_wrapper.interruptSession();
    }
    if (this.timer != null) {
      clearTimeout(this.timer);
    }
  },
  created() {
    this.log("PSpeech:created");
    this.log("lessonState: " + this.$store.getters.lessonState);
    this.init();
  },
  mounted() {
    this.log("PSpeech:mounted");

    this.setCards2();

    // 自動調整初期処理
    this.initAutoAdjustParrot();
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/style/card";

.toparea-mic {
  .item {
    width: 300px;
    height: 53px;
    word-break: break-all;
    white-space: normal;
    position: relative;
    cursor: default;
    padding-right: 50px;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: $dgray;
      position: absolute;
      right: 0;
      width: 3px;
    }
    &::-webkit-scrollbar {
      width: 10px;
      background-color: $dgray;
      position: absolute;
      right: 0;
      width: 3px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: $dgray;
      border: 2px solid $dgray;
      position: absolute;
      right: 0;
      width: 3px;
    }

    .mic-icon {
      position: absolute;
      top: 5px;
      right: 5px;
      z-index: 3;
      background: url(#{$imgpath}mic/mic_base.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_1 {
      background: url(#{$imgpath}mic/mic_01.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_2 {
      background: url(#{$imgpath}mic/mic_02.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_3 {
      background: url(#{$imgpath}mic/mic_03.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_4 {
      background: url(#{$imgpath}mic/mic_04.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_5 {
      background: url(#{$imgpath}mic/mic_05.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_6 {
      background: url(#{$imgpath}mic/mic_06.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_7 {
      background: url(#{$imgpath}mic/mic_07.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_8 {
      background: url(#{$imgpath}mic/mic_08.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_9 {
      background: url(#{$imgpath}mic/mic_09.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
    .mic-icon.score_10 {
      background: url(#{$imgpath}mic/mic_10.png) no-repeat;
      background-position: center;
      background-size: 40px 34px;
      display: inline-block;
      width: 40px;
      height: 34px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// PSpeech.vue?840903bc